import styled, { css } from "styled-components"
import { FormGroup } from "../admin-page/admin-page.styles";

const InfrastructureTabs = styled.div`
  display: flex;
  gap: 0.9375rem;
  width: 100%;
  padding: 0.3125rem 0.625rem;
  align-items: center;
  border-radius: 0.3125rem;
  background: #F2EFDE;
  max-width: 100%;
  overflow-x: auto;
  height: 2rem;
  margin-bottom: 0.9375rem;

  ::-webkit-scrollbar {
    height: 2px; 
    margin-bottom: 0.625rem;
  }
  
  ::-webkit-scrollbar-track {
    background-color: transparent;
    margin-bottom: 0.625rem; 
  }
  
  ::-webkit-scrollbar-thumb {
    background-color: #98A3A9; 
    border-radius: 5px;
    border-left: 15px solid transparent; 
    border-right: 35px solid transparent;
    background-clip: padding-box;
  }
`;

const InfrastructureTab = styled.div<{ selected?: boolean }>`
  color: ${({ selected }) => selected ? '#202224' : '#606367'};
  font-weight: ${({ selected }) => selected ? ' 700' : '400'};
  border-bottom: ${({ selected }) => selected ? ' 1px solid #202224' : 'none'};
  font-size: 0.75rem;
  cursor: pointer;  
  white-space: nowrap;
`;

const EducationReportContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
  max-width: 100%;
  overflow-y: auto;
  max-height: calc(100vh - 15rem);
  padding-right: 0.625rem;
  ::-webkit-scrollbar {
    width: 2px;
    margin-right: 0.625rem;
  }
  
  ::-webkit-scrollbar-track {
    background-color: transparent; /* You can set a background color here if needed */
    margin-right: 0.625rem;

  }
  
  ::-webkit-scrollbar-thumb {
    background-color: #98A3A9;
    border-radius: 5px; 
    border-top: 15px solid transparent;
    border-bottom: 35px solid transparent;
    background-clip: padding-box;
  }
`

const EducationObject = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  color: #000;
  font-size: 0.875rem;
  font-weight: 600;
  border-radius: 5px;
  border: 1px solid #DBDCE0;
  background: #fff;
  padding: 0.625rem 0.9375rem;
  cursor: pointer;
  &:nth-child(2n) {
    background: #F5F5F5;
  }

  svg path {
    stroke: #98A3A9;
    cursor: pointer;
  }
`;

const AddEducationObject = styled.button`
  all: unset;
  font-size: 0.875rem;
  font-weight: 600;
  color: #FFF;
  display: flex;
  gap: 0.625rem;
  padding: 0.5rem 0.9375rem;
  border-radius: 5px;
  background: #4F7FAE;
  align-self: flex-start;
  cursor: pointer;
  align-items: center;

  &:disabled {
    background: #98A3A9;
    cursor: default;
  }
`;

const FormBlock = styled.div<{ isStreet?: boolean }>`
  border-radius: 5px;
  background: #F5F5F5;
  padding: 0.3125rem;
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
  margin-bottom: 1.25rem;

  .title {
    color: #606367;
    font-size:  0.75rem;;
  }

  .row {
    display: flex;
    gap: 1.25rem;
    justify-content: space-between;
    align-items: center;
    white-space: nowrap;
   
    ${FormGroup} {
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      gap: 0.625rem;  

      label {
        white-space: nowrap;
      }

      input {
        height: 1.8125rem;
        max-width: 8rem;
      }
    }

    &.sb {
      ${FormGroup} {
        width: 100%;
        input,
        select {
          height: 1.8125rem;
          max-width: 100%;
          flex: 1;
        }
      }
    }


    &.wrap {
      ${FormGroup} {
        justify-content: space-between;
        label {
          max-width: 33%;
          white-space: initial;
        }

        input,
        select {
          max-width: 20rem;
        }
      }
    }

    &.sport {
      ${FormGroup} {
        justify-content: space-between;
        input {
          max-width: 15rem;
        }
      }
    }
  }

  ${({ isStreet }) => isStreet && css`
    position: relative;
    .delete-street {
      position: absolute;
      top: 5px;
      right: 5px;
      font-size: 1rem;
      cursor: pointer;
      z-index: 10;
    }
  `}

  ${FormGroup} {
    margin-bottom: 0;

    input {
      font-weight: 400;
      font-size: 0.75rem;
    }
  }

  .grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0.625rem;

    ${FormGroup} {
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      max-width: 100%;
    }

    input {
      max-width: 9rem;
    }

    &.roads {
      input,
      select {
        max-width: 8rem;
      }
    }
  }

  .add-info__buttons{
    display: flex;
    gap: 0.625rem;
  }
`;

const FormBlockButton = styled.div`
  all: unset;
  display: flex;
  align-items: center;
  gap: 0.625rem;
  color: #4F7FAE;
  font-size: 0.875rem;
  font-weight: 700;
  cursor: pointer;
`;

const InfrastructureButtonsContainer = styled.div`
  display: flex;
  gap: 0.625rem;
  margin-top: 0.625rem;
  align-items: center;

  .checkbox-container{
    display: flex;
    align-items: center;
    gap: 0.625rem;
    font-size: 0.875rem;
    font-weight: 700;
    cursor: pointer;
  }
`;

export {
  InfrastructureTabs,
  InfrastructureTab,
  EducationReportContainer,
  EducationObject,
  AddEducationObject,
  FormBlock,
  FormBlockButton,
  InfrastructureButtonsContainer
}
